import React, { useState,useRef,useEffect } from "react";

import AdminPage from "../AdminPage";
import axios from "axios";
import { SERVERURL } from "../../../ServerUrl";
import Swal from "sweetalert2";



const COPY = {
  title: "Add Partner",
  subtitle: "Upload New Partner",
  name: "Name",
  namePlaceholder: "Name of Partner",
  image: "Image",
  upload: "Upload",
};

const AddPartner = () => {
  const [name, setName] = useState("");
  const [image, setImage] = useState(null);
  const [imgPreview, setImgPreview] = useState(null);
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const errors = {};
  
    if (!name.trim()) {
      errors.name = "Name is required";
    }
  
    if (!image) {
      errors.image = "Image is required";
    }
  
    setErrors(errors);
  
    return Object.keys(errors).length === 0;
  };
  const handleImageChange = (e) => {
    const selected = e.target.files[0];
    setImage(selected);

    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      let reader = new FileReader();
      reader.onloadend = () => {
        setImgPreview(reader.result);
      };
      reader.readAsDataURL(selected);
    } else {
      // Handle error if the file type is not allowed
    }
  };

  const uploadOnServer = async () => {
    if (!validateForm()) {
      return;
    }
    try {

      const form = new FormData();
      form.append("fullName", name);
      form.append("file", image);
      const token = localStorage.getItem('token'); 
      const headers = {
        'Authorization': `Bearer ${token}`, // Corrected header format
      };
      const response = await axios.post(`${SERVERURL}/api/v1/AddPartner`, form, {
        headers: headers, // Include the headers object in the request configuration
      });

          if(response.data.success === true)
          {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: "Partner Added Successfully.",
            });
            setName("");
            setImage(null);
            setImgPreview(null);
            if (imageInputRef.current) {
              imageInputRef.current.value = null;
            }
          }
          else {
            Swal.fire({
              icon: "error",
              title: response.data.message,
             text: "",
            });
          }
      
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "An error occurred",
        text: "Partner Not Added.",
      });
      console.error("Error registering partner:", error);
    }
  };
const imageInputRef = useRef(null);
  return (
    <AdminPage title={COPY.title} subtitle={COPY.subtitle}>
      <div className="admin-card" style={{ maxWidth: "560px" }}>
        <div className="admin-form-grid">
          <div className="admin-field">
            <label className="admin-label" htmlFor="name">
              {COPY.name}
            </label>
            <input
              id="name"
              type="text"
              placeholder={COPY.namePlaceholder}
              className="admin-input"
              value={name}
              onChange={handleNameChange}
            />
            {errors.name && <p className="admin-error">⚠ {errors.name}</p>}
          </div>

          <div className="admin-field">
            <label className="admin-label" htmlFor="image">
              {COPY.image}
            </label>
            <input
              id="image"
              type="file"
              ref={imageInputRef}
              accept="image/png , image/jpeg, image/webp"
              className="admin-input admin-file"
              onChange={handleImageChange}
            />
            {errors.image && <p className="admin-error">⚠ {errors.image}</p>}
          </div>

          {imgPreview && (
            <img src={imgPreview} alt="Preview" className="admin-preview" />
          )}
        </div>

        <div className="admin-form-actions">
          <button className="admin-btn" type="button" onClick={uploadOnServer}>
            {COPY.upload}
          </button>
        </div>
      </div>
    </AdminPage>
  );
};

export default AddPartner;

